import React from 'react';
import {
  CompleteStatusStyled,
  IconStyled,
  ModalStyled,
  ProgressDoneStyled,
  ProgressStyled,
  TitleStyled,
} from './styles';

interface Props {
  show: boolean;
  onClose: () => void;
  attemptNumber: number;
}

const ContinuousRatesPullingModal = ({ show, attemptNumber, onClose }: Props): JSX.Element => {
  const progressDone = (attemptNumber + 1) * 10;
  const calculatedProgress = progressDone <= 100 ? `${progressDone}%` : '100%';
  const validatedProgressDone = progressDone > 0 ? calculatedProgress : 0;

  return (
    <ModalStyled show={show} onClose={onClose} closable={false}>
      <IconStyled width="8rem" $attemptNumber={attemptNumber} />
      {attemptNumber > -1 ? (
        <>
          <TitleStyled>Please wait while we retrieve rates</TitleStyled>
          <CompleteStatusStyled>{`${validatedProgressDone} complete`}</CompleteStatusStyled>
          <ProgressStyled>
            <ProgressDoneStyled $validatedProgressDone={validatedProgressDone} />
          </ProgressStyled>
        </>
      ) : (
        <TitleStyled>Almost done, we’re updating your catalog</TitleStyled>
      )}
    </ModalStyled>
  );
};

export default ContinuousRatesPullingModal;
